import "./Header.css";

interface BannerProps {
  bannerTypePreRelease: string | undefined;
  bannerURL: string | undefined;
  diaBanner: string | undefined;
  mesBanner: string | undefined;
}

export default function Banner({ bannerTypePreRelease, bannerURL, diaBanner, mesBanner }: BannerProps) {
  function handleClickSaibaMais() {
    window.open(bannerURL, "_blank");
  }

  const isPreRelease = bannerTypePreRelease === "true";

  return (
    <div className="container-banner-release">
      {isPreRelease ? (
        <>
          <div className="data-container-banner">
            <h3>{diaBanner}</h3>
            <p>{mesBanner}</p>
          </div>
          <div className="texto-banner-release">
            <p>
              <strong>Novas melhorias estarão disponíveis! </strong> Não deixe de conferir as novidades que preparamos
              para você!
            </p>
          </div>
          <div className="botoes-banner-release">
            <button className="botao-banner-release-saibamais" onClick={handleClickSaibaMais}>
              <svg width="38" height="32" viewBox="0 0 38 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M34.3952 15.5439C35.3152 15.5439 36.1952 15.5439 37.0752 15.5439C37.3152 15.5439 37.6052 15.5439 37.6452 15.8139C37.6752 15.9939 37.5552 16.2639 37.4152 16.4039C35.9152 17.9239 34.4052 19.4239 32.8952 20.9339C32.5152 21.3139 32.3852 21.3139 32.0052 20.9339C30.4952 19.4239 28.9852 17.9239 27.4852 16.4039C27.3452 16.2639 27.2052 15.9639 27.2652 15.8239C27.3252 15.6839 27.6252 15.5739 27.8252 15.5639C28.7052 15.5339 29.5752 15.5539 30.4852 15.5539C30.5152 14.3139 30.3452 13.1439 29.9452 12.0239C28.3652 7.5539 25.2452 4.8039 20.5752 4.0439C16.9252 3.4539 13.6352 4.4439 10.8852 6.9939C10.0152 7.7939 8.98517 7.8839 8.19517 7.2239C7.34517 6.5139 7.25517 5.2439 8.05517 4.4739C10.5652 2.0539 13.5352 0.5339 17.0252 0.1139C24.0452 -0.7361 30.4152 3.2539 33.0952 9.3239C33.8752 11.0939 34.3152 12.9439 34.3852 14.8739C34.3852 15.0839 34.4052 15.2839 34.4152 15.5439H34.3952Z"
                  fill="#1D1D1B"
                />
                <path
                  d="M3.25497 15.5439C2.33497 15.5439 1.45497 15.5439 0.574966 15.5439C0.334966 15.5439 0.054966 15.5439 0.00496602 15.2739C-0.025034 15.1039 0.0849672 14.8539 0.224967 14.7139C1.74497 13.1739 3.27497 11.6539 4.79497 10.1239C5.13497 9.7839 5.28497 9.7839 5.63497 10.1239C7.16497 11.6539 8.69497 13.1739 10.205 14.7139C10.335 14.8439 10.455 15.1339 10.395 15.2739C10.335 15.4139 10.055 15.5239 9.86497 15.5239C8.97497 15.5539 8.08497 15.5339 7.17497 15.5339C7.13497 16.7539 7.30497 17.8939 7.68497 18.9939C9.25497 23.5039 12.385 26.2739 17.095 27.0439C20.715 27.6339 23.985 26.6539 26.725 24.1339C27.125 23.7639 27.535 23.4539 28.105 23.4239C28.925 23.3739 29.655 23.8039 29.985 24.5339C30.305 25.2539 30.165 26.0839 29.585 26.6439C27.365 28.7739 24.775 30.2139 21.755 30.7939C13.685 32.3639 5.70497 27.2739 3.75497 19.2939C3.49497 18.2439 3.44497 17.1539 3.29497 16.0839C3.27497 15.9239 3.27497 15.7539 3.26497 15.5339L3.25497 15.5439Z"
                  fill="#1D1D1B"
                />
              </svg>
              <p>SAIBA MAIS!</p>
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="d-flex justify-content-center align-items-end position-relative svg-container">
            <svg className="svg-icon" viewBox="0 0 100 89" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_77_298)">
                <path
                  d="M3.64193e-05 3.60723L7.35477 3.60723C54.1005 3.60722 91.2132 42.9404 88.5 89.6072V89.6072C91.2132 42.9404 54.1005 3.60722 7.35477 3.60723L3.64193e-05 3.60723Z"
                  stroke="#278F8F"
                  strokeWidth="2"
                />
                <path
                  d="M-0.0234545 27.1724C-0.575586 27.1854 -1.01264 27.6435 -0.999652 28.1957C-0.986659 28.7478 -0.528535 29.1849 0.0235971 29.1719L-0.0234545 27.1724ZM4.17742 28.0738L4.15389 27.0741L4.17742 28.0738ZM0.0235971 29.1719L4.20094 29.0736L4.15389 27.0741L-0.0234545 27.1724L0.0235971 29.1719ZM4.20094 29.0736C36.6499 28.31 62.3898 56.2219 59.0055 88.503L60.9946 88.7115C64.5046 55.2311 37.8084 26.2821 4.15389 27.0741L4.20094 29.0736Z"
                  fill="#278F8F"
                />
              </g>
              <defs>
                <clipPath id="clip0_77_298">
                  <rect width="100" height="89" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div className="texto-banner-release">
            <p>
              <strong>Agora você tem novas funcionalidades</strong> para facilitar ainda mais a{" "}
              <strong>gestão do seu condomínio.</strong>
            </p>
          </div>
          <div className="botoes-banner-release">
            <button className="botao-banner-release-saibamais" onClick={handleClickSaibaMais}>
              <svg width="38" height="32" viewBox="0 0 38 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M34.3952 15.5439C35.3152 15.5439 36.1952 15.5439 37.0752 15.5439C37.3152 15.5439 37.6052 15.5439 37.6452 15.8139C37.6752 15.9939 37.5552 16.2639 37.4152 16.4039C35.9152 17.9239 34.4052 19.4239 32.8952 20.9339C32.5152 21.3139 32.3852 21.3139 32.0052 20.9339C30.4952 19.4239 28.9852 17.9239 27.4852 16.4039C27.3452 16.2639 27.2052 15.9639 27.2652 15.8239C27.3252 15.6839 27.6252 15.5739 27.8252 15.5639C28.7052 15.5339 29.5752 15.5539 30.4852 15.5539C30.5152 14.3139 30.3452 13.1439 29.9452 12.0239C28.3652 7.5539 25.2452 4.8039 20.5752 4.0439C16.9252 3.4539 13.6352 4.4439 10.8852 6.9939C10.0152 7.7939 8.98517 7.8839 8.19517 7.2239C7.34517 6.5139 7.25517 5.2439 8.05517 4.4739C10.5652 2.0539 13.5352 0.5339 17.0252 0.1139C24.0452 -0.7361 30.4152 3.2539 33.0952 9.3239C33.8752 11.0939 34.3152 12.9439 34.3852 14.8739C34.3852 15.0839 34.4052 15.2839 34.4152 15.5439H34.3952Z"
                  fill="#1D1D1B"
                />
                <path
                  d="M3.25497 15.5439C2.33497 15.5439 1.45497 15.5439 0.574966 15.5439C0.334966 15.5439 0.054966 15.5439 0.00496602 15.2739C-0.025034 15.1039 0.0849672 14.8539 0.224967 14.7139C1.74497 13.1739 3.27497 11.6539 4.79497 10.1239C5.13497 9.7839 5.28497 9.7839 5.63497 10.1239C7.16497 11.6539 8.69497 13.1739 10.205 14.7139C10.335 14.8439 10.455 15.1339 10.395 15.2739C10.335 15.4139 10.055 15.5239 9.86497 15.5239C8.97497 15.5539 8.08497 15.5339 7.17497 15.5339C7.13497 16.7539 7.30497 17.8939 7.68497 18.9939C9.25497 23.5039 12.385 26.2739 17.095 27.0439C20.715 27.6339 23.985 26.6539 26.725 24.1339C27.125 23.7639 27.535 23.4539 28.105 23.4239C28.925 23.3739 29.655 23.8039 29.985 24.5339C30.305 25.2539 30.165 26.0839 29.585 26.6439C27.365 28.7739 24.775 30.2139 21.755 30.7939C13.685 32.3639 5.70497 27.2739 3.75497 19.2939C3.49497 18.2439 3.44497 17.1539 3.29497 16.0839C3.27497 15.9239 3.27497 15.7539 3.26497 15.5339L3.25497 15.5439Z"
                  fill="#1D1D1B"
                />
              </svg>
              <p>SAIBA MAIS!</p>
            </button>
          </div>
        </>
      )}
    </div>
  );
}
